import { sharedFetchFormData } from '../shared/formsActions';
import getClient from '../../../utils/reading/formsUtils';

const fetchFormData = (measure, formUid) => sharedFetchFormData(formUid, getClient(measure));

export default fetchFormData;
